var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sports-menu" },
    [
      _c(
        "nav",
        [
          _c("site-navigation", {
            staticClass: "popular expand navigation topmenu",
            attrs: { "navigation-section": "SPORTS_MENU_TOP" }
          }),
          _vm._v(" "),
          _c("site-navigation", {
            staticClass: "popular expand navigation",
            attrs: { "navigation-section": "BO_POPULAR" }
          }),
          _vm._v(" "),
          (_vm.xtremepushWebInitialized || _vm.xtremePushEnabledMobile) &&
          _vm.xtremepushOnSiteEnabled &&
          _vm.xtremepushInlineContent &&
          _vm.mobileBigAndBelow
            ? _c("xtremepush-inline-content", {
                ref: "xtremepushInlineRef",
                attrs: { section: "all_sports" },
                on: {
                  xtremepushInlineContentToAllSportsNavigationDrawer:
                    _vm.xtremepushInlineContentToAllSportsNavigationDrawer
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrapper sports-az az-icon navigation" },
            [
              _c("h3", [
                _vm.brandTemplate !== "generic_2"
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Sports.SportAZ")))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.brandTemplate === "generic_2"
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Sports.AllSportsAZ")))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("bo-navigation", {
                attrs: {
                  "p-idfwbonavigation": "top",
                  "order-by-name": true,
                  "preselect-first-node": false
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("site-navigation", {
            staticClass: "popular expand navigation mainmenu",
            attrs: { "navigation-section": "SPORTS_MENU_BOTTOM" }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.MobilelocalServer && _vm.supportedLocale.length > 1
        ? _c("language-switcher", {
            staticClass: "popular expand navigation mainmenu",
            attrs: { id: "lang" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f75210e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f75210e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/sportsMenu.vue
// module id = null
// module chunks = 